import { jsx as _jsx } from "react/jsx-runtime";
export function DrawerFooter({ children }) {
    return (_jsx("div", { slot: "controls", className: "flex w-full items-center justify-end gap-4 border-t-small border-neutral-200 p-4", children: children }));
}
